import React from "react";
import LoadingDialog from "../../molecules/loadingDialog";
import { Flex } from "@fluentui/react-northstar";

const LoadingOverlay = (props) => {
    const { content } = props;

    return (
        <Flex className="page loading-overlay" data-testid="loadingOverlay">
            <LoadingDialog content={content} />
        </Flex>
    );
};

export default LoadingOverlay;